import React from "react";
import { DIVISIONS } from "../../../src/constants.js"
import DivisionalReportsPage from "./DivisionalReportsPage.js";

export default function CaroogaReports() {
  return <DivisionalReportsPage division={DIVISIONS.CAROOGA}/>
};